import { CheckCircleSharp, ErrorSharp } from "@mui/icons-material";
import { Card, Typography } from "@mui/material";

type ComponentProps = {
  isTask: boolean;
  titleOverview: string;
  data: any;
};

const UrgentTask = ({ isTask, data, titleOverview }: ComponentProps) => {
  return (
    <Card className="p-4 mb-4">
      <Typography variant="body1" className="font-semibold mb-2">
        Urgent {titleOverview}
      </Typography>
      <div className="grid grid-cols-1 gap-2">
        <div
          className="col-span-1"
          style={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "16px",
          }}
        >
          <div className="flex gap-4 items-center">
            <div className="w-[64px] h-[64px] rounded-lg bg-success flex items-center justify-center">
              <CheckCircleSharp className="text-white w-8 h-8" />
            </div>
            <div className="flex flex-col gap-2">
              <div className="text-success font-bold text-sm uppercase">
                URGENT {titleOverview} COMPLETED
              </div>
              <div className="text-success text-3xl font-bold">
                {isTask
                  ? data?.urgent_complete_count_today || 0
                  : data?.urgent_complete_count_today_qty || 0}
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-span-1"
          style={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "16px",
          }}
        >
          <div className="flex gap-4 items-center">
            <div className="w-[64px] h-[64px] rounded-lg bg-error flex items-center justify-center">
              <ErrorSharp className="text-white w-8 h-8" />
            </div>
            <div className="flex flex-col gap-2">
              <div className="text-error font-bold text-sm uppercase">
                PENDING URGENT {titleOverview}
              </div>
              <div className="text-error-dark text-3xl font-bold">
                {isTask
                  ? data?.today?.urgent_task_created || 0
                  : data?.today_qty?.urgent_task_created || 0}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default UrgentTask;
